// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ln5nl","content":"styles_content__2Nl1O"};